import { styled } from "styled-components";
import { Flex, CalculateIcon, IconButton } from "@pulsex/uikit";

const ApyLabelContainer = styled(Flex)`
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
`;

export interface FarmApyButtonProps {
  hideButton?: boolean;
  strikethrough?: boolean;
  variant: "text" | "text-and-button";
  handleClickButton: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const FarmApyButton: React.FC<React.PropsWithChildren<FarmApyButtonProps>> = ({
  hideButton,
  variant,
  strikethrough,
  handleClickButton,
  children,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (hideButton) return;
    handleClickButton(event);
  };

  return (
    <Flex flexDirection="column" alignItems="flex-start">
      <ApyLabelContainer
        alignItems="center"
        style={{ textDecoration: strikethrough ? "line-through" : "initial" }}
        onClick={handleClick}
      >
        {children}
        {variant === "text-and-button" && (
          <IconButton variant="text" scale="xs" ml="4px" style={{ height: "auto", padding: 0 }}>
            <CalculateIcon width="18px" color="textSubtle" />
          </IconButton>
        )}
      </ApyLabelContainer>
    </Flex>
  );
};
